import { ActionType, getType } from 'typesafe-actions';
import { IRestaurantStore } from '../../interfaces';
import * as actions from './restaurant-actions';
import { RestaurantUtils } from '@localina/core';

const initialState: IRestaurantStore = {
    availableAreaTimes: [],
    availableShifts: [],
    isLoading: false,
    hasError: false,
};

// eslint-disable-next-line
export default function restaurantReducer(state: IRestaurantStore = initialState, action: ActionType<typeof actions>) {
    switch (action.type) {
        case getType(actions.restaurantConfigurationRequested):
        case getType(actions.restaurantMenuRequested):
            return { ...state, isLoading: true, hasError: false };
        case getType(actions.restaurantConfigurationReceived):
            return {
                ...state,
                isLoading: false,
                hasError: false,
                configuration: {
                    ...action.payload.configuration,
                    shifts: action.payload.configuration.shifts.map((shift) => {
                        return {
                            ...shift,
                            shiftAreas: RestaurantUtils.getAreaShiftList(shift, action.payload.configuration),
                        };
                    }),
                    closingDays: action.payload.configuration.closingDays.map((closingDay) => {
                        return {
                            ...closingDay,
                            areas: RestaurantUtils.getAreasForClosingDay(closingDay, action.payload.configuration),
                        };
                    }),
                },
            };
        case getType(actions.restaurantMenuReceived):
            return {
                ...state,
                isLoading: false,
                hasError: false,
                menu: action.payload,
            };
        case getType(actions.restaurantConfigurationFailed):
            return { ...state, isLoading: false, hasError: true };
        case getType(actions.restaurantAvailableTimesRequested):
            return { ...state, isLoading: true, hasError: false };
        case getType(actions.shiftsRequested):
            return { ...state, isLoading: true, hasError: false };
        case getType(actions.restaurantAvailableTimesReceived):
            return {
                ...state,
                isLoading: false,
                hasError: false,
                availableAreaTimes: action.payload.availableTimes.slots,
            };
        case getType(actions.restaurantAvailableTimesFailed):
            return { ...state, isLoading: false, hasError: true, availableAreaTimes: [] };
        case getType(actions.shiftsReceived):
            return {
                ...state,
                isLoading: false,
                hasError: false,
                availableShifts: action.payload.shifts,
            };
        case getType(actions.shiftsError):
            return { ...state, isLoading: false, hasError: true, availableShifts: [] };
        default:
            return state;
    }
}
